module.exports = __webpack_public_path__ + "static/media/chess-bishop.8945d916.svg";